import { useCreateEmailForwarding } from "@/queries/email-forwardings/create";
import { useDeleteEmailForwarding } from "@/queries/email-forwardings/delete";
import { useGetAllEmailForwardings } from "@/queries/email-forwardings/get-all";
import { useUpdateEmailForwarding } from "@/queries/email-forwardings/update";
import { ErrorMessage } from "@/components/ui/error";
import { ForwardingIntegrations } from "./forwarding-integrations";

export const ForwardingIntegrationsContainer = () => {
  const { emailForwardings, loading, error } = useGetAllEmailForwardings();

  const { createEmailForwarding } = useCreateEmailForwarding();
  const { deleteEmailForwarding } = useDeleteEmailForwarding();
  const { updateEmailForwarding } = useUpdateEmailForwarding();

  const handleCreateEmailForwarding = ({
    alias,
    description,
  }: { alias?: string; description?: string }) => {
    return createEmailForwarding({
      alias,
      description,
    });
  };

  const handleDeleteEmailForwarding = (emailForwardingId: string) => {
    return deleteEmailForwarding(emailForwardingId);
  };

  const handleUpdateEmailForwarding = async ({
    emailForwardingId,
    alias,
    description,
    isActive,
  }: {
    emailForwardingId: string;
    alias?: string;
    description?: string;
    isActive?: boolean;
  }) => {
    await updateEmailForwarding({
      emailForwardingId,
      alias,
      description,
      isActive,
    });
  };

  if (error) {
    return (
      <div className="flex justify-center items-center h-full p-4">
        <ErrorMessage />
      </div>
    );
  }

  return (
    <ForwardingIntegrations
      emailForwardings={emailForwardings}
      loading={loading}
      onDeleteEmailForwarding={handleDeleteEmailForwarding}
      onUpdateEmailForwarding={handleUpdateEmailForwarding}
      onCreateEmailForwarding={handleCreateEmailForwarding}
    />
  );
};
